<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h3 class="panel-title">Product Performance</h3>
    </div>
    <div class="panel-body" v-if="!productPerformance || !productPerformance.by_revenue || productPerformance.by_revenue.length === 0">
      <p class="text-muted">No product data available.</p>
    </div>
    <table v-else class="table table-striped table-hover">
      <thead>
        <tr>
          <th v-for="col in columns" :key="col.key" style="cursor: pointer;" @click="sortByColumn(col.key)">
            {{ col.label }}
            <CalculationTooltip v-if="col.tooltip" :text="col.tooltip" />
            <span v-if="sortKey === col.key">
              <i :class="sortAsc ? 'fa fa-sort-asc' : 'fa fa-sort-desc'"></i>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in sortedRows" :key="row.product_name">
          <td>{{ row.product_name }}</td>
          <td>{{ inDollars(row.total_revenue) }}</td>
          <td>{{ row.units_sold.toLocaleString() }}</td>
          <td>{{ row.percent_of_total }}%</td> <!-- DS-PORT-DEFECT (drivescout-vue3 M6 slice 5, 2026-10-17): row S5-product-table-percent-key: the API key is percentage_of_total (EcommerceDashboardController::getProductPerformance), so row.percent_of_total is undefined and the cell prints a bare %; FIXED in the port (owner ruling 2026-10-18) -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import CalculationTooltip from '../../scheduling-dashboard/components/CalculationTooltip.vue';
import { inDollars } from '../../../../DriveScout/Billing/Teller';

export default {
  name: 'ProductPerformanceTable',
  components: { CalculationTooltip },
  props: {
    productPerformance: { type: Object, required: true }
  },
  data: function() {
    return {
      sortKey: 'total_revenue',
      sortAsc: false
    };
  },
  computed: {
    columns: function() {
      return [
        { key: 'product_name', label: 'Product Name', tooltip: null },
        { key: 'total_revenue', label: 'Revenue', tooltip: 'Total revenue from this product.' },
        { key: 'units_sold', label: 'Units Sold', tooltip: 'Number of units of this product sold.' },
        { key: 'percent_of_total', label: '% of Total', tooltip: 'This product\'s revenue as a percentage of total revenue.' } // DS-PORT-DEFECT (drivescout-vue3 M6 slice 5, 2026-10-17): row S5-product-table-percent-key: the API key is percentage_of_total, so sorting this column compares undefined and never reorders the rows; FIXED in the port (owner ruling 2026-10-18)
      ];
    },
    sortedRows: function() {
      if (!this.productPerformance || !this.productPerformance.by_revenue) return [];
      var key = this.sortKey;
      var asc = this.sortAsc;
      var rows = this.productPerformance.by_revenue.slice();
      rows.sort(function(a, b) {
        var valA = a[key];
        var valB = b[key];
        if (typeof valA === 'string') {
          valA = valA.toLowerCase();
          valB = valB.toLowerCase();
        }
        if (valA < valB) return asc ? -1 : 1;
        if (valA > valB) return asc ? 1 : -1;
        return 0;
      });
      return rows;
    }
  },
  methods: {
    inDollars: inDollars,
    sortByColumn: function(key) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    }
  }
};
</script>
